<template>
    <el-container class="ms-system-box">
        <el-header>
            <el-row>
                <el-col :span="18" class="tl">
                    <div class="homeLogo fl">
                        <img src="@/assets/image/login-logo.png" alt="" />
                    </div>
                    <b class="homeName">{{ userInfo.title }}</b>
                </el-col>
                <el-col :span="6" class="tr">
                    <el-link :underline="false" @click="loginOut">退出登录</el-link>
                </el-col>
            </el-row>
        </el-header>
        <el-container class="ms-main">
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import { getStorage, removeAllStorage } from "@/common/storage"
export default {
    data() {
        return {
            menu: "",
            userInfo: getStorage('USERINFO'),
        };
    },
    methods: {
        loginOut() {
            this.$confirm("确定退出登录吗？", "提示").then(() => {
                removeAllStorage()
                this.$router.push("/");
            });
        },
    },
};
</script>
<style lang="scss">
.ms-system-box {
    height: 100%;
    width: 100%;
    overflow: hidden;

    .ms-main {
        height: calc(100% - 72px);
        .el-main{
            padding: 0;
        }
    }

    .tl {
        a {
            text-decoration: none;
        }
    }

    .el-header {
        height: 72px !important;
        line-height: 72px;
        background: #fff;
        color: #17233D;
        font-size: 20px !important;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);

        .el-row {
            max-width: 1024px;
            margin: 0 auto;

            .tl{
                text-overflow: ellipsis;
                overflow: hidden;
                height: 72px;
                white-space: nowrap;
            }

            .homeLogo {
                height: 36px;
                line-height: 36px;
                box-sizing: border-box;
                margin-top: 18px;
                margin-right: 10px;

                img {
                    height: 100%;
                    vertical-align: middle;
                }
            }
        }

        .tr {
            float: right;
        }

    }
}
</style>